import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import Registration from './pages/Registration';
import Onboard from './pages/Onboard';
import Login from './pages/Login';
import LoginSuccess from './pages/LoginSuccess';
import Dashboard from './pages/Dashboard';
import Share from './pages/Share';
import MyCredentials from './pages/MyCredentials';
import TrustedDevices from './pages/TrustedDevices';
import ProfileUpdate from './pages/ProfileUpdate';
import ProfileEdit from './pages/ProfileEdit';
import TenantConfigurations from './pages/TenantConfigurations';
import { FlashMessageProvider } from './context/FlashMessageContext';
import './App.css';

function App() {
  return (
    <FlashMessageProvider>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/onboard" element={<Onboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login-success" element={<LoginSuccess />} />
            <Route path="/auth/verify-login" element={<LoginSuccess />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/share" element={
              <ProtectedRoute>
                <Share />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/credentials" element={
              <ProtectedRoute>
                <MyCredentials />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/trusted-devices" element={
              <ProtectedRoute>
                <TrustedDevices />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/profile-update" element={
              <ProtectedRoute>
                <ProfileUpdate />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/profile-update/edit" element={
              <ProtectedRoute>
                <ProfileEdit />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/tenant-configurations" element={
              <ProtectedRoute>
                <TenantConfigurations />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/tenant-configurations/:tenantId" element={
              <ProtectedRoute>
                <TenantConfigurations />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
      </div>
    </FlashMessageProvider>
  );
}

export default App;
